import { Component, Input, Output, EventEmitter, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {
  @Input() collapsible?: boolean;
  @Input() isGrouped?: boolean;        // Explicit override
  @Input() nameList?: any[];
  @Input() groupedItems?: any[];
  @Input() title?: string;
  @Input() selectedItem?: any;
  @Input() selectedName?: any;
  @Input() company?: any;
  @Input() itemTemplate?: TemplateRef<any>;

  @Output() itemSelected = new EventEmitter<any>();

  // Collapse state tracking
  private _isCollapsed = false;
  groupCollapseState: { [key: string]: boolean } = {};

  // Auto-detect mode from data
  get isCollapsible(): boolean {
    return this.collapsible ?? false;
  }

  get isCollapsed(): boolean {
    return this._isCollapsed;
  }
  get flatListData(): any[] {
    return this.nameList || [];
  }

  get groupListData(): any[] {
    return this.groupedItems || [];
  }
  get hasData(): boolean {
    return this.flatListData.length > 0 || this.groupListData.length > 0;
  }
  toggle(): void {
    this._isCollapsed = !this._isCollapsed;
  }
  isGroupCollapsed(group: any): boolean {
    const key = this.getGroupKey(group);
    return this.groupCollapseState[key] ?? true;
  }
  hasGroupMembers(group: any): boolean {
    return (group.items?.length > 0 || group.memberNames?.length > 0 || group.members?.length > 0);
  }
  getGroupMembers(group: any): any[] {
     return group.items || group.memberNames || group.members || [];  // ← Added 'items'
  }
  getGroupKey(group: any): string {
    return group.id || group.name || group.mnemonic || JSON.stringify(group);
  }
  onItemSelect(item: any): void {
    this.itemSelected.emit(item);

    if (this.isCollapsible && this.isGrouped) {
      // Find which group contains this item
      const selectedGroup = this.groupListData.find(group =>
        this.getGroupMembers(group).some(m =>
          m === item || this.getDisplayName(m) === this.getDisplayName(item)
        )
      );
  
      if (selectedGroup) {
        const selectedKey = this.getGroupKey(selectedGroup);
  
        // Close all groups except this one
        Object.keys(this.groupCollapseState).forEach(k => {
          this.groupCollapseState[k] = k !== selectedKey; 
        });
  
        // Open selected group
        this.groupCollapseState[selectedKey] = false;
      }
    }
  }

  isSelected(item: any): boolean {
    // For simple flat list: match by reference OR display name
    const displayName = this.getDisplayName(item);
    return item === this.selectedItem || 
         displayName === this.selectedName || 
         displayName === this.selectedItem;
  }

  getDisplayName(item: any): string {
    return item?.name || item?.label || item || '';
  }
}
